import { search } from "../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/faturamento/contratos/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function getListasContract({
  empresaCnpj,
  companyId,
  paramValues,
  include,
}) {
  let stringParam = "";
  Object.entries(paramValues).forEach(([key, value]) => {
    if (value) stringParam += `&${key}=${value}`;
  });
  return search(
    `${path}/get-listas?empresa_cnpj=${empresaCnpj}&companyId=${companyId}${stringParam}${
      include ? `&include=${include}` : ""
    }`,
    "GET",
    headers
  );
}

export async function sendCancelContract({ empresa_cnpj, body }) {
  return search(
    `${path}/cancelar-contrato?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
}

export async function suspensionContract({ empresa_cnpj, body }) {
  return search(
    `${path}/suspender-contrato?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
}

export async function activeContract({ empresa_cnpj, body }) {
  return search(
    `${path}/ativar-contrato?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
}

export async function showContract({ empresa_cnpj, idContract, include }) {
  return search(
    `${path}/${idContract}?empresa_cnpj=${empresa_cnpj}${
      include && `&include=${include}`
    }`,
    "GET",
    headers
  );
}

export async function customShowContract({
  empresa_cnpj,
  idContract,
  gfToken,
}) {
  return search(
    `${path}/custom/${idContract}?empresa_cnpj=${empresa_cnpj}&gfAccessToken=${gfToken}`,
    "GET",
    headers
  );
}

export async function editContract({ empresa_cnpj, idContract, body }) {
  return search(
    `${path}/${idContract}?empresa_cnpj=${empresa_cnpj}`,
    "PUT",
    headers,
    body
  );
}

export async function attachmentsContract({ empresa_cnpj, idContract }) {
  return search(
    `${path}/contrato-anexos/${idContract}?empresa_cnpj=${empresa_cnpj}`,
    "GET",
    headers
  );
}

export async function includeService({ empresa_cnpj, body }) {
  return search(
    `${path}/incluir-servico?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
}

export function createContrato({ empresa_cnpj, body }) {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "POST", headers, body);
}

export function includeAttachments({ empresa_cnpj, idContract, body }) {
  return search(
    `${path}/incluir-anexos/${idContract}?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
}

export function removeAttachments({ empresa_cnpj, idContract, body }) {
  return search(
    `${path}/remover-anexos/${idContract}?empresa_cnpj=${empresa_cnpj}`,
    "DELETE",
    headers,
    body
  );
}

export function removeService({ empresa_cnpj, body }) {
  return search(
    `${path}/remover-servico?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
}

export const getCancelLists = async ({ contractId, empresa_cnpj }) => {
  return search(
    `${path}/cancelamento-listas/${
      contractId || ""
    }?empresa_cnpj=${empresa_cnpj}`,
    "GET",
    headers
  );
};

export const addServiceContract = async ({ empresa_cnpj, body }) => {
  return search(
    `${path}/incluir-servico?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
};

export const alterCrValue = async ({ empresa_cnpj, body }) => {
  return search(
    `${path}/reajuste-abatimento?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
};

export const findContractSinglebyCr = async ({ empresa_cnpj, id_cr }) => {
  return search(
    `${path}/buscar-servicos-cr?empresa_cnpj=${empresa_cnpj}&id_cr=${id_cr}`,
    "GET",
    headers
  );
};

export const findContasReceberEmAberto = async ({
  empresa_cnpj,
  idContrato,
}) => {
  return search(
    `${path}/conta-receber-abertos-contrato/${idContrato}?empresa_cnpj=${empresa_cnpj}`,
    "GET",
    headers
  );
};

export async function upsertContractService({ empresa_cnpj, body }) {
  return search(
    `${path}/upsert-servico?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
}

export async function findContrato({
  empresa_cnpj,
  id,
  include,
  page,
  where = {},
  orWhere = {},
  isSameOrWhere = false,
  orderByColumn,
  whereIn = {},
}) {
  let queryWhere = "";
  Object.keys(where).forEach((key) => {
    queryWhere += `&where[${key}]=${where[key]}`;
  });

  let queryOrWhere = "";
  Object.keys(orWhere).forEach((key) => {
    queryOrWhere += `&orWhere${isSameOrWhere ? "[]" : ""}[${key}]=${
      orWhere[key]
    }`;
  });

  let queryWhereIn = "";
  Object.keys(whereIn).forEach((row) => {
    queryWhereIn += `&wherein[${row}]=${whereIn[row]}`;
  });

  return search(
    `${path}${
      id ? `/${id}` : ""
    }?empresa_cnpj=${empresa_cnpj}${queryWhere}${queryOrWhere}${
      include ? `&include=${include}` : ""
    }${queryWhereIn ?? ""}${page ? `&page=${page}` : ""}${
      orderByColumn ? "&orderBy=" + orderByColumn : ""
    }`,
    "GET",
    headers
  );
}
